import React from "react";
import { useSelector } from "react-redux";
import { BASE_URL } from "../../constant/apiUrl";
import InternalPageLayout from "../InternalPages/InternalPageLayout";
import Loading from "../../utils/Loader";
import useFetchInternal from "../../hooks/useFetchInternal";

export default function DynamicPage({ slug, header, pageId }) {
  const { pages } = useSelector((s) => s.internalPage) || [];

  const { loading, nodata } = useFetchInternal(
    `${BASE_URL}/internal-pages/page-info/find-by-page-id?pageId=${pageId}`,
    slug
  );

  if (loading) return <Loading />;

  return (
    <InternalPageLayout
      pageData={pages[slug]}
      header={header}
      slug={slug}
      data-testid={slug}
      nodata={nodata}
    />
  );
}
